export default __webpack_public_path__ + "static/media/adwords.5697171e.jpg";